// src/pages/PrivateLogin.jsx
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { login } from "../lib/adminApi.js";

// Only allow in-site relative redirects after login.
function safeNext(value) {
  return typeof value === "string" && value.startsWith("/") && !value.startsWith("//") ? value : "/";
}

export default function PrivateLogin() {
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const next = safeNext(searchParams.get("next"));

  // The password is verified by the admin API on the server; nothing secret
  // exists in this bundle.
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setError("");
    try {
      await login(pwd);
      setPwd("");
      navigate(next, { replace: true });
    } catch (err) {
      setError(
        err.status === 401 ? "Incorrect password"
          : err.status === 429 ? "Too many attempts. Please try again later."
            : err.message || "Login failed. Please try again."
      );
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-sm mx-auto mt-24 p-6 bg-white rounded shadow">
      <h1 className="text-xl font-semibold mb-4">Admin Login</h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="admin-password" className="text-sm block mb-1">Password</label>
          <input
            id="admin-password"
            type="password"
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            className="w-full border rounded px-3 py-2"
            autoComplete="current-password"
            autoFocus
            required
          />
        </div>


        {error && <div className="text-sm text-red-600" role="alert">{error}</div>}

        <button
          type="submit"
          disabled={submitting}
          className="w-full bg-blue-600 text-white rounded py-2 hover:bg-blue-700 transition disabled:opacity-60"
        >
          {submitting ? "Signing in…" : "Login"}
        </button>
      </form>
    </div>
  );
}
